import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockdownApp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.440 1.193 C 1.825 1.353,1.368 1.782,1.163 2.391 C 1.081 2.634,1.080 2.694,1.080 6.569 C 1.081 8.840,1.098 10.703,1.121 10.980 C 1.408 14.420,2.697 17.336,4.987 19.721 C 6.663 21.467,9.017 22.963,11.380 23.782 C 11.490 23.820,11.734 23.860,11.922 23.870 C 12.241 23.888,12.297 23.878,12.742 23.729 C 14.945 22.989,17.353 21.450,19.013 19.721 C 21.303 17.336,22.592 14.420,22.879 10.980 C 22.902 10.703,22.919 8.840,22.920 6.569 C 22.920 2.694,22.919 2.634,22.837 2.391 C 22.746 2.122,22.550 1.802,22.373 1.633 C 22.311 1.574,22.155 1.462,22.026 1.385 C 21.553 1.101,22.264 1.120,11.972 1.122 C 3.381 1.124,2.681 1.130,2.440 1.193 M21.119 6.230 C 21.118 10.534,21.074 11.374,20.774 12.720 C 20.380 14.489,19.542 16.236,18.413 17.640 C 17.815 18.384,16.865 19.296,16.055 19.905 C 15.044 20.664,13.561 21.488,12.465 21.899 L 11.989 22.078 11.425 21.854 C 10.117 21.336,8.867 20.622,7.720 19.736 C 7.190 19.327,5.978 18.139,5.583 17.640 C 4.212 15.911,3.365 13.931,3.042 11.700 C 2.912 10.801,2.881 9.747,2.881 6.250 L 2.880 2.960 12.000 2.960 L 21.120 2.960 21.119 6.230 ",
		fill: "#42296E",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgLockdownApp;
